import React from "react"

const DmsContent = ({ className="mt-20 flex-1 w-full mx-auto container mb-10", children }) =>
  <div className={ className }>
    { children }
  </div>
export default DmsContent;
